import styled from 'styled-components';
import { RedirectionModalStyled } from '../RedirectionModalStyled';

export const RedirectionModalStyledDS = styled(RedirectionModalStyled)``;
